import React, { useEffect, useState } from 'react';
export function ProgressBar() {
  const [scrollProgress, setScrollProgress] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const totalScroll = document.documentElement.scrollTop;
      const windowHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const scroll = totalScroll / windowHeight;
      setScrollProgress(scroll);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="fixed top-11 left-0 w-full h-[3px] z-50 bg-brand-dark/50" data-id="element-351">
      <div className="h-full bg-gradient-to-r from-brand-teal to-brand-cyan transition-all duration-150 ease-out shadow-[0_0_10px_rgba(20,184,166,0.5)]" style={{
      width: `${scrollProgress * 100}%`
    }} data-id="element-352" />
    </div>;
}